module.exports = __webpack_public_path__ + "static/indexfand-0547bf480201818fe1defb5a9ca4e79c.webp";